export default {
  eyebrow: 'Partnerportaal',
  title: 'Transactiekosten',
  description:
    'Jij betaalt de kosten van Stripe voor elke online betaling. De hier ingestelde transactiekosten worden aan je restaurants in rekening gebracht om deze te dekken, tenzij een restaurant een eigen tarief heeft.',
  card_title: 'Standaard transactiekosten',
  hint: 'Percentage in %, plus een optioneel vast bedrag en minimumbedrag per betaling. „Elke betaalmethode” geldt wanneer er geen methodespecifiek tarief bestaat. Een wijziging geldt voor betalingen die worden gedaan nadat deze is opgeslagen.',
  hint_single:
    'De verwerkingskosten gelden voor elke online betaalmethode die geen eigen tarief heeft. Een wijziging geldt voor betalingen die worden gedaan nadat deze is opgeslagen.',
  hidden_rates:
    'Sommige betaalmethoden hebben ook een eigen tarief, ingesteld door de support van je platform. Die gelden in plaats van dit tarief.',
  empty: {
    title: 'Geen standaard transactiekosten ingesteld',
    description:
      'Totdat je dit instelt, of bevestigt dat je je restaurants geen verwerkingskosten in rekening brengt, kunnen je restaurants met Stripe niet live gaan en ontvangen live restaurants geen online betalingen (contant werkt nog steeds).',
  },
  consent: {
    give: 'Wij betalen de kosten van Stripe zelf (bevestig een marge van 0%)',
    given_title: 'Marge van 0% bevestigd',
    given:
      'Bevestigd door {{name}} op {{date}}: restaurants zonder eigen tarief betalen geen verwerkingskosten en jij betaalt de kosten van Stripe voor hun betalingen.',
    unknown_manager: 'een voormalige manager',
    withdraw: 'Intrekken',
    withdraw_confirm: {
      title: 'Bevestiging van 0% marge intrekken?',
      description:
        'Restaurants zonder eigen tarief kunnen dan niet live gaan en live restaurants nemen geen onlinebetalingen meer aan totdat je een tarief instelt of opnieuw bevestigt.',
    },
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  toasts: {
    load_error: 'Kan je transactiekosten niet laden.',
    failed_to_save_changes: 'Kan je transactiekosten niet opslaan.',
    changes_got_saved: 'Transactiekosten opgeslagen',
    consent_given: 'Marge van 0% bevestigd',
    consent_withdrawn: 'Bevestiging ingetrokken',
  },
};
